"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getTimestamp = exports.getSN = exports.getDateObject = exports.expireCallback = exports["default"] = void 0;
var _callFunc = _interopRequireDefault(require("call-func"));
//@ts-check

/**
 * @param {number|string} t
 */
var getDateObject = function getDateObject(t) {
  return null != t ? new Date(t) : new Date();
};

/**
 * @param {number|string} [t]
 */
exports.getDateObject = getDateObject;
var getTimestamp = function getTimestamp(t) {
  return +getDateObject( /** @type {number|string}*/t);
};

/**
 * milliseconds (thousandths of a second)
 * @param {number} createTime
 * @param {number} expireMilliseconds
 * @param {function|null} run
 * @param {function|null} expireCb
 */
exports.getTimestamp = getTimestamp;
var expireCallback = function expireCallback(createTime, expireMilliseconds, run, expireCb) {
  var now = getTimestamp();
  var isExpire = true;
  if (null != createTime && !isNaN(createTime)) {
    if (!expireMilliseconds || now - createTime <= expireMilliseconds) {
      isExpire = false;
    }
  }
  return isExpire ? (0, _callFunc["default"])(expireCb) : (0, _callFunc["default"])(run);
};
exports.expireCallback = expireCallback;
var sn = {};

/**
 * @param {string} [name]
 * @param {string} [separator]
 */
var getSN = function getSN(name, separator) {
  var _sn$name;
  if (separator === void 0) {
    separator = "_";
  }
  sn[name] = (_sn$name = sn[name]) !== null && _sn$name !== void 0 ? _sn$name : 0;
  return (name || "") + separator + sn[name]++;
};
exports.getSN = getSN;
var getRandom = function getRandom() {
  return getTimestamp() + "" + Math.random();
};
var _default = getRandom;
exports["default"] = _default;